module.exports = __webpack_public_path__ + "media/images/icon-favorite-active-d6a8f2cf7cc99973ca2e84e1691532af.svg";